<template>
	<fragment name="fade" v-if="config.show">
		<div class="modal-box">
			<div class="modal modal p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">
						링크등록
					</h2>
					<a class="close" @click="$emit('close')">&times;</a>
				</div>
				<div class="modal-body p-10 clearfix">
					<span class="inline p-l-10">주소 입력</span>
					<input class="form-control full-width round" v-model="config.link">
				</div>
				<div class="modal-footer p-10" style="background-color: #f8f8f8;">
					<button class="btn bg-deepblue half-width text-white round" @click="$emit('regLink',config)">등록</button>
					<button class="btn bg-red half-width text-white round" @click="$emit('close')">취소</button>
				</div>
			</div>
		</div>
		<modal-alert
		:config="modals.ModalAlert"
		@close="modals.ModalAlert.show=config.show=false;"
		:key="hash(modals.ModalAlert)"
		></modal-alert>
	</fragment>
</template>

<script>
import Axios from 'axios';
import server from '../statics/server.js'
import ModalAlert from "../modals/ModalAlert.vue";

export default {
	name: "ModalMenuRegisterLink",
	components: {
		ModalAlert,
	},
	default: function() {
		return {
			categoryId : this.categoryId,
			link: this.link,
			show: false
		}
	},
	data: function() {
		return {
			categoryId: "",
			link: "",
			modals: {
				ModalAlert: ModalAlert.default(),
			}
		}
	},
	methods: {
		regLink : async function(){
			const link = this.config.link;
			try {
				await Axios.patch(`${server.addr()}${server.api.MENU}/${this.config.categoryId}`, {
					link
				});
				this.modals.ModalAlert.msg = "등록되었습니다.";
				this.modals.ModalAlert.show = true;
			} catch(e) {
				console.log(e);
				// TODO: 서버쪽 오류랑 매핑시킬 것!
				this.modals.ModalAlert.msg = "서버와 통신할 수 없습니다.";
				this.modals.ModalAlert.show = true;
			}
		}
	},
	props: {
		config: Object
	}
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>